<template>
  <b-modal :id="`modalVinculacaoSelo_${_uid}`"
           modal-class="modalVinculacaoSelo"
           body-class="modalVinculacaoSelo_body"
           header-class="modalVinculacaoSelo_header"
           :visible="true"
           hide-header
           hide-footer
           centered
           size="xl"
           @hide="voltar()">
    <CollapseDefault :id="`vinculacao_selo_${_uid}`"
                     icons-class="icon--xxs"
                     :style-default="true"
                     header-class="header-blue"
                     :collapse-visible="resultadoBusca.length === 0"
                     :icons-show="true">
      <template v-slot:header>
        Busca de selo em registro

        <small v-if="resultadoBusca.length > 0"
               class="text-bold text-info">
          (Clique aqui para mostrar os filtros de pesquisa)
        </small>
      </template>

      <template v-slot:content>
        <form novalidate
              @submit.prevent="getRegistros()">
          <div class="row col-12">
            <div class="col-2 mt-3 pl-0">
              <label :for="`busca_cpf_registrado_${_uid}`"
                     class="label">
                CPF do Registrado
              </label>

              <input :id="`busca_cpf_registrado_${_uid}`"
                     :ref="`busca_cpf_registrado_${_uid}`"
                     v-model="busca.cpfRegistrado"
                     v-mask="`999.999.999-99`"
                     type="text"
                     placeholder="000.000.000-00"
                     class="form-control form-control-sm"
                     :name="`busca_cpf_registrado_${_uid}`">
            </div>

            <div class="col-10 mt-3">
              <label :for="`busca_nome_registrado_${_uid}`"
                     class="label">
                Nome do Registrado
              </label>

              <input :id="`busca_nome_registrado_${_uid}`"
                     v-model="busca.nomeRegistrado"
                     v-uppercase
                     type="text"
                     class="form-control form-control-sm"
                     placeholder="Digite o nome para pesquisa"
                     :name="`busca_nome_registrado_${_uid}`">
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-5 mt-3">
              <div class="row no-gutters justify-content-between align-items-center">
                <div v-for="tipoLivro in tipoLivros"
                     :key="tipoLivro.valor"
                     class="radioBox d-inline-flex align-items-center tipos-registros-anteriores"
                     :class="{ 'active': tipoLivro.valor === busca.tipoRegistro, 'radioBoxDisabled': tipoLivro.disabled }"
                     @click="selectTipoRegistro(tipoLivro)">
                  <label class="radioBox_btn w-100 text-center position-relative"
                         :class="{ 'radioBoxDisabled_btn': tipoLivro.disabled }"
                         :for="`busca_tipo_livro_${tipoLivro.text}`">
                    <svg v-if="tipoLivro.icon"
                         class="radioBox_icon icon--md"
                         role="presentation">
                      <use :xlink:href="'#' + tipoLivro.icon.id" />
                    </svg>

                    <input :id="`busca_tipo_livro_${tipoLivro.text}`"
                           v-model="busca.tipoRegistro"
                           class="radioBox_input position-absolute"
                           :class="{ 'radioBoxDisabled_input': tipoLivro.disabled }"
                           :name="`busca_tipo_livro_${tipoLivro.text}`"
                           type="radio"
                           :value="tipoLivro.valor"
                           :disabled="tipoLivro.disabled">
                    <span class="radioBox_title w-100 d-inline-block">{{ tipoLivro.text }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="col-4 d-flex align-items-end justify-content-end">
              <div class="row">
                <div class="col mb-1">
                  <label :for="`busca_num_livro_${_uid}`"
                         class="label">
                    Livro
                  </label>

                  <input :id="`busca_num_livro_${_uid}`"
                         v-model="busca.numLivro"
                         v-validate="'min_value:1'"
                         class="form-control form-control-sm"
                         min="1"
                         maxlength="5"
                         :name="`busca_num_livro_${_uid}`"
                         type="number"
                         placeholder="00000">
                </div>

                <div class="col">
                  <label :for="`busca_num_folha_${_uid}`"
                         class="label">
                    Folha
                  </label>

                  <input :id="`busca_num_folha_${_uid}`"
                         v-model="busca.numFolha"
                         v-validate="'min_value:1'"
                         class="form-control form-control-sm"
                         min="1"
                         maxlength="3"
                         :name="`busca_num_folha_${_uid}`"
                         type="number"
                         placeholder="000">
                </div>

                <div class="col-5">
                  <label :for="`busca_num_termo_${_uid}`"
                         class="label">
                    Termo
                    <small>(Registro)</small>
                  </label>

                  <input :id="`busca_num_termo_${_uid}`"
                         v-model="busca.numTermo"
                         v-validate="'min_value:1'"
                         class="form-control form-control-sm"
                         min="1"
                         maxlength="7"
                         :name="`busca_num_termo_${_uid}`"
                         type="number"
                         placeholder="0000000">
                </div>
              </div>
            </div>
          </div>

          <div v-if="['N', 'O'].indexOf(busca.tipoRegistro) >= 0"
               class="row">
            <div class="col">
              <div class="modalVinculacaoSelo--tipoBox p-2 pl-3 pr-3">
                <div class="row mt-2 mb-2">
                  <div class="col">
                    <label :for="`busca_nome_genitor_1_${_uid}`"
                           class="label">
                      Nome do Genitor 1
                    </label>

                    <input :id="`busca_nome_genitor_1_${_uid}`"
                           v-model="busca.nomeGenitor1"
                           v-uppercase
                           type="text"
                           :name="`busca_nome_genitor_1_${_uid}`"
                           class="form-control form-control-sm"
                           placeholder="Digite o nome para pesquisa">
                  </div>

                  <div class="col">
                    <label :for="`busca_nome_genitor_2_${_uid}`"
                           class="label">
                      Nome do Genitor 2
                    </label>

                    <input :id="`busca_nome_genitor_2_${_uid}`"
                           v-model="busca.nomeGenitor2"
                           v-uppercase
                           type="text"
                           :name="`busca_nome_genitor_2_${_uid}`"
                           class="form-control form-control-sm"
                           placeholder="Digite o nome para pesquisa">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="busca.tipoRegistro === 'C'"
               class="row modalVinculacaoSelo--tipoBox ml-0 mr-0">
            <div class="col">
              <div class="mt-2 pr-3">
                <div class="row">
                  <label class="col-1 mb-0 mt-1">
                    Mostrar:
                  </label>

                  <b-form-radio :id="`busca_hab_casamento_${_uid}`"
                                v-model="busca.tipoRegistroCasamento"
                                class="modalVinculacaoSelo_tipos_casamento"
                                :name="`busca_hab_casamento_${_uid}`"
                                value="D">
                    Habilitação
                  </b-form-radio>

                  <b-form-radio :id="`busca_reg_casamento_${_uid}`"
                                v-model="busca.tipoRegistroCasamento"
                                class="modalVinculacaoSelo_tipos_casamento"
                                :name="`busca_reg_casamento_${_uid}`"
                                value="C">
                    Registro
                  </b-form-radio>
                </div>
              </div>
            </div>

            <div class="col-12 mt-2">
              <div class="d-flex justify-content-between row">
                <label for="conjuge"
                       class="col-10">Nome do Cônjuge</label>

                <b-form-checkbox v-if="busca.tipoRegistroCasamento === 'C'"
                                 :id="`busca_casamento_religioso_${_uid}`"
                                 v-model="busca.casamentoReligioso"
                                 class="col text-right"
                                 :name="`busca_casamento_religioso_${_uid}`">
                  Religioso
                </b-form-checkbox>
              </div>
            </div>

            <div class="col-12 mb-3">
              <input :id="`busca_conjuge_${_uid}`"
                     v-model="busca.nomeConjuge"
                     v-uppercase
                     class="form-control form-control-sm"
                     :name="`busca_conjuge_${_uid}`"
                     placeholder="Digite o nome para pesquisa"
                     type="text">
            </div>
          </div>

          <div class="row mt-3 no-gutters">
            <div class="col-4 col-sm">
              <label :for="`busca_data_registro_inicio_${_uid}`"
                     class="label">
                Data do Registro
              </label>

              <div class="row no-gutters">
                <div class="col-5">
                  <input :id="`busca_data_registro_inicio_${_uid}`"
                         v-model="busca.dataRegistroInicial"
                         :name="`busca_data_registro_inicio_${_uid}`"
                         type="date"
                         class="form-control form-control-sm">
                </div>

                <div class="col-1 d-flex align-items-end justify-content-center">
                  <b>até</b>
                </div>

                <div class="col-5">
                  <input :id="`busca_data_registro_final_${_uid}`"
                         v-model="busca.dataRegistroFinal"
                         :name="`busca_data_registro_final_${_uid}`"
                         type="date"
                         class="form-control form-control-sm">
                </div>
              </div>
            </div>

            <div class="col-4 col-sm">
              <label :for="`busca_data_ocorrido_inicio_${_uid}`"
                     class="label">
                Data do Ocorrido
              </label>

              <div class="row no-gutters">
                <div class="col-5">
                  <input :id="`busca_data_ocorrido_inicio_${_uid}`"
                         v-model="busca.dataOcorridoInicial"
                         :name="`busca_data_ocorrido_inicio_${_uid}`"
                         type="date"
                         class="form-control form-control-sm">
                </div>

                <div class="col-1 d-flex align-items-end justify-content-center">
                  <b>até</b>
                </div>

                <div class="col-5">
                  <input :id="`busca_data_ocorrido_final_${_uid}`"
                         v-model="busca.dataOcorridoFinal"
                         :name="`busca_data_ocorrido_final_${_uid}`"
                         type="date"
                         class="form-control form-control-sm">
                </div>
              </div>
            </div>

            <div class="col-2 d-flex align-items-end justify-content-left">
              <b-button variant="outline-primary"
                        class="btn btn-sm"
                        type="submit">
                Pesquisar
              </b-button>
            </div>
          </div>

          <div class="mt-4 border-top border-primary pt-3" />
        </form>
      </template>
    </CollapseDefault>

    <div v-if="resultadoBusca.length > 0"
         class="row no-gutters col-12 justify-content-end align-items-center pr-0 mt-3">
      <label :for="`busca_order_${_uid}`"
             class="col-1 form-group mb-0 pt-1">
        Ordernar por
      </label>

      <div class="pl-2 col-2">
        <select :id="`busca_order_${_uid}`"
                v-model="orderBy"
                class="custom-select custom-select-sm"
                :name="`busca_order_${_uid}`"
                @change="getRegistros()">
          <option :value="null">
            Selecione
          </option>

          <option v-for="ord in orderList"
                  :key="ord.value"
                  :value="ord.value">
            {{ ord.desc }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="resultadoBusca.length > 0"
         class="container RegistrosResultados_resultado mt-3 mb-3 pl-0 pr-0">
      <div v-for="(registro, index) in resultadoBusca"
           :key="`resultado_registro_${index}`"
           class="row RegistrosResultados mb-3 ml-1 mr-1">
        <div class="col"
             :class="{ 'RegistrosResultados_opacity' : disableSelectRegistro(index) }">
          <div class="row RegistrosResultados--header"
               :class="{ 'RegistrosResultados--header--click' : !disableSelectRegistro(index)}">
            <div class="col">
              <div class="row no-gutters">
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-radio :id="`selecionarRegistroSelo_${index}`"
                                v-model="indexRegistroSelected"
                                :value="index"
                                :name="`selecionarRegistroSelo_${index}`"
                                :disabled="disableSelectRegistro(index)"
                                @keyup.native.enter="indexRegistroSelected = index" />
                </div>

                <div class="d-flex align-items-center justify-content-center"
                     :class="{ 'RegistrosResultados_titulo_nascimento_casamento': ['N', 'C'].indexOf(registro.tipo_registro) >= 0,
                               'RegistrosResultados_titulo_cas_reg': registro.tipo_registro === 'CR',
                               'RegistrosResultados_titulo_hab': registro.tipo_registro === 'D',
                               'RegistrosResultados_titulo_obito': ['NT', 'O'].indexOf(registro.tipo_registro) >= 0 }">
                  <icon-svg v-if="['C', 'CR', 'D'].indexOf(registro.tipo_registro) >= 0"
                            icon="engagement"
                            class="icon--sm" />

                  <icon-svg v-if="registro.tipo_registro === 'N'"
                            icon="nascimento"
                            class="icon--sm" />

                  <icon-svg v-if="['NT', 'O'].indexOf(registro.tipo_registro) >= 0"
                            icon="flower"
                            class="icon--sm" />

                  <h5 class="ml-2 RegistrosResultados--tipo">
                    {{ registro.tipo_registro === 'N' ? 'Nascimento' :
                      registro.tipo_registro === 'C' ? 'Casamento' :
                      registro.tipo_registro === 'CR' ? 'Casamento Religioso' :
                      registro.tipo_registro === 'D' ? 'Habilitação de Casamento' :
                      ['NT', 'O'].indexOf(registro.registro_id) ? 'Óbito' : '' }}
                  </h5>
                </div>

                <div class="col-3 pl-2 RegistrosResultados--table-width">
                  <table class="RegistrosResultados--table">
                    <tr>
                      <th>Livro</th>
                      <th>Folha</th>
                      <th>Termo</th>
                      <th>Ocorrido</th>
                      <th>Registrado</th>
                    </tr>

                    <tr>
                      <td>{{ registro.livro.num_livro }}</td>
                      <td>{{ registro.folha }}</td>
                      <td>{{ registro.termo }}</td>
                      <td>{{ (registro.data_ocorrido || '') }}</td>
                      <td>{{ (registro.data_registro || '') }}</td>
                    </tr>
                  </table>
                </div>

                <div v-if="registro.livro.cartorio.endereco"
                     class="col pl-2 d-flex align-items-center">
                  <icon-svg icon="mapMarker"
                            class="icon--sm" />

                  <table class="RegistrosResultados--cartorio">
                    <tr>
                      <th>
                        <b>{{ registro.livro.cartorio.endereco.cidade + '/' + registro.livro.cartorio.endereco.uf }}</b>
                      </th>
                    </tr>

                    <tr>
                      <td>
                        <b>{{ registro.livro.cartorio.nome }}</b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="['N', 'O', 'NT'].indexOf(registro.tipo_registro) >= 0"
               class="row">
            <div class="col-12 py-2">
              <div class="row">
                <div class="col-4">
                  <label>
                    <div>
                      <u>Registrado</u>
                    </div>

                    <div>
                      <b>{{ registro.pessoa.nome }}</b>
                    </div>
                  </label>
                </div>

                <div class="col-5">
                  <label>
                    <div>
                      <u>Genitor(es)</u>
                    </div>

                    <div v-if="registro.pessoa.genitores.length > 0">
                      <div v-if="registro.pessoa.genitores[0]">
                        <small>
                          1) {{ registro.pessoa.genitores[0].pessoa.nome }}
                        </small>
                      </div>

                      <div v-if="registro.pessoa.genitores[1]">
                        <small>
                          2) {{ registro.pessoa.genitores[1].pessoa.nome }}
                        </small>
                      </div>
                    </div>

                    <div v-else>
                      <small>Genitores não informado</small>
                    </div>
                  </label>
                </div>

                <div class="col-3">
                  <label>
                    <div>
                      <u>Selos</u>
                    </div>

                    <div>
                      <b>{{ registro.selos.length }}</b>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div v-if="['C', 'CR', 'D'].indexOf(registro.tipo_registro) >= 0"
               class="row">
            <div class="col-12 py-2">
              <div class="row">
                <div class="col-5">
                  <label>
                    <div>
                      <u>Cônjuge 1</u>
                    </div>

                    <div v-if="['C', 'CR'].indexOf(registro.tipo_registro) >= 0">
                      <b>{{ registro.casamento.registro.pessoas[0].nome_antigo }}</b>
                    </div>

                    <div v-else>
                      <b>{{ registro.habilitacaoCasamento.registro.pessoas[0].nome_antigo }}</b>
                    </div>
                  </label>
                </div>

                <div class="col-5">
                  <label>
                    <div>
                      <u>Cônjuge 2</u>
                    </div>

                    <div v-if="['C', 'CR'].indexOf(registro.tipo_registro) >= 0">
                      <b>{{ registro.casamento.registro.pessoas[1].nome_antigo }}</b>
                    </div>

                    <div v-else>
                      <b>{{ registro.habilitacaoCasamento.registro.pessoas[1].nome_antigo }}</b>
                    </div>
                  </label>
                </div>

                <div class="col-2">
                  <label>
                    <div>
                      <u>Selos</u>
                    </div>

                    <div>
                      <b>{{ registro.selos.length }}</b>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="resultadoBusca.length > 0"
         class="row mt-3 mb-3">
      <div class="col-10 paginate d-inline-flex justify-content-center align-items-center">
        <p class="paginate_text small d-inline-block mt-0"
           style="padding-left: 20.5%">
          Página
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': (Number(page) === 1) }"
                :disabled="(Number(page) === 1)"
                type="button"
                title="Página anterior"
                @click="paginaAnterior()">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_left.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          <select v-model="page"
                  class="form-control form-control-sm"
                  @change="selecionaPagina(page)">
            <option v-for="(value, index) in lastPage"
                    :key="`option_paginate_dashboard_${ index }_${ _uid }`">
              {{ value }}
            </option>
          </select>
        </p>

        <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                :class="{ 'inactive': Number(page) === lastPage }"
                :disabled="(Number(page) === lastPage)"
                type="button"
                title="Próxima página"
                @click="proximaPagina()">
          <svg class="paginate_icon icon--xxs"
               role="presentation">
            <use :xlink:href="'#' + arrow_right.id" />
          </svg>
        </button>

        <p class="paginate_text small d-inline-block mt-0">
          {{ `de ${lastPage}` }}
        </p>
      </div>
    </div>

    <div class="mt-3 border modalVinculacaoSelo_border-color row no-gutters justify-content-end align-items-center">
      <div class="d-inline-block mt-3 mb-3">
        <button class="btn btn-sm modalVinculacaoSelo_botao-voltar pl-2"
                type="button"
                @click="voltar()"
                @keyup.enter="voltar()">
          Voltar
        </button>
      </div>

      <div class="d-inline-block ml-2 mt-3 mb-3 mr-3">
        <button class="btn btn-sm btn-primary"
                type="button"
                :disabled="typeof indexRegistroSelected === 'object' ? true : false"
                @click="concluiSelecionarRegistro()"
                @keyup.enter="concluiSelecionarRegistro()">
          Escolher registro
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import moment from 'moment'

  /* assets */
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'

  /* services */
  import BuscaService from '@/services/BuscaService'

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* components */
  import CollapseDefault from '@/components/SofiaRei/Resumo/Collapses/CollapseDefault'

  /* icons */
  import icon_casamento from "@/assets/icons/engagement.svg?sprite"
  import icon_nasc from "@/assets/icons/baby-buggy.svg?sprite"
  import icon_obito from "@/assets/icons/flower.svg?sprite"
  import icon_livroe from "@/assets/icons/book-open-variant.svg?sprite"

  export default {
    name: 'BuscaSelosOutrosRegistros',
    components: {
      CollapseDefault
    },
    props: {
      propRegistroId: { type: Number, default: () => null },
      propCpfRegistrado: { type: String, default: () => null },
      propNomeRegistrado: { type: String, default: () => null },
      propHabilitacao: { type: Object, default: () => null }
    },
    data () {
      return {
        // Lista de livros para a busca
        tipoLivros: [
          {
            text: 'Nascimento',
            id: 1,
            valor: 'N',
            icon: icon_nasc,
            disabled: false
          },
          {
            text: 'Casamento',
            id: 2,
            valor: 'C',
            icon: icon_casamento,
            disabled: false
          },
          {
            text: 'Óbito',
            id: 3,
            valor: 'O',
            icon: icon_obito,
            disabled: false
          },
          {
            text: 'Livro-E',
            id: 4,
            valor: 'L',
            icon: icon_livroe,
            disabled: true
          }
        ],

        // Variáveis para busca
        busca: {
          cpfRegistrado: null,
          nomeRegistrado: null,
          tipoRegistro: 'N',
          tipoRegistroCasamento: 'C',
          casamentoReligioso: false,
          nomeConjuge: null,
          numLivro: null,
          numFolha: null,
          numTermo: null,
          nomeGenitor1: null,
          nomeGenitor2: null,
          dataRegistroInicial: null,
          dataRegistroFinal: null,
          dataOcorridoInicial: null,
          dataOcorridoFinal: null
        },

        // Variável para o último registro pesquisado
        tipoRegistroPesquisado: null,

        // Array de registros pesquisados
        resultadoBusca: [],

        // Registro selecionado
        indexRegistroSelected: null,

        // Paginate
        page: 1,
        lastPage: 1,
        perPage: 5,

        // Icons
        arrow_left,
        arrow_right,

        // Tipo de ordernação
        orderBy: null,
        orderList: [
          {
            id: 1,
            desc: 'Nome',
            value: 'NOME'
          },
          {
            id: 2,
            desc: 'Registro',
            value: 'REGISTRO'
          },
          {
            id: 3,
            desc: 'Data Registro',
            value: 'DATA_REGISTRO'
          },
          {
            id: 4,
            desc: 'Data Ocorrido',
            value: 'DATA_OCORRIDO'
          }
        ]
      }
    },
    beforeMount () {
      this.busca.cpfRegistrado = this.propCpfRegistrado
      this.busca.nomeRegistrado = this.propNomeRegistrado

      setTimeout(() => {
        if (this.$refs[`busca_cpf_registrado_${this._uid}`]) {
          this.$refs[`busca_cpf_registrado_${this._uid}`].focus()
        }
      }, 100)
    },
    mounted () {
      if (this.propHabilitacao) {
        this.tratarSugestao(this.propHabilitacao)
      }
    },
    methods: {
      voltar () {
        this.$emit('voltar')
      },

      async getRegistros () {
        // Fazemos esse dois ifs abaixo para facilitar a validação de tipo atual com o último pesquisado
        if (this.busca.tipoRegistro === 'C' && this.busca.tipoRegistroCasamento === 'C' && this.busca.casamentoReligioso) {
          this.busca.tipoRegistro = 'CR'
        }

        if (this.busca.tipoRegistro === 'C' && this.busca.tipoRegistroCasamento === 'D') {
          this.busca.tipoRegistro = 'D'
        }

        this.page = this.tipoRegistroPesquisado === this.busca.tipoRegistro ? this.page : 1

        // Voltamos o tipo como estava
        if (['CR', 'D'].indexOf(this.busca.tipoRegistro) >= 0) {
          this.busca.tipoRegistro = 'C'
        }

        const params = {
          tipo_livro: this.busca.tipoRegistro,
          tipo_registro: this.busca.tipoRegistro,
          cartorio_id: this.$store.state.auth.cartorio_id,
          page: this.page,
          perPage: this.perPage,
          flag_somente_rascunhos: false, // fixo
          religioso: false,
          cancelado: false // filtramos os registros ativos e não cancelados
        }

        if (this.busca.cpfRegistrado) {
          params.cpf = filterMaskedNumber(this.busca.cpfRegistrado)
        }

        if (this.busca.nomeRegistrado) {
          params.nome = this.busca.nomeRegistrado
        }

        if (this.busca.numLivro) {
          params.num_livro = this.busca.numLivro
        }

        if (this.busca.numFolha) {
          params.num_folha = this.busca.numFolha
        }

        if (this.busca.numTermo) {
          params.termo = this.busca.numTermo
        }

        if (this.busca.nomeGenitor1) {
          params.nomeGenitor1 = this.busca.nomeGenitor1
        }

        if (this.busca.nomeGenitor2) {
          params.nomeGenitor2 = this.busca.nomeGenitor2
        }

        if (this.busca.dataRegistroInicial) {
          params.data_registro_inicio = this.busca.dataRegistroInicial
        }

        if (this.busca.dataRegistroInicial) {
          params.data_registro_fim = this.busca.dataRegistroFinal
        }

        if (this.busca.dataOcorridoInicial) {
          params.data_ocorrido_inicio = this.busca.dataOcorridoInicial
        }

        if (this.busca.dataOcorridoFinal) {
          params.data_ocorrido_fim = this.busca.dataOcorridoFinal
        }

        if (this.busca.tipoRegistro === 'O') {
          delete params.tipo_registro

          params.tipo_livro = ['O', 'NT']
        }

        if (this.busca.tipoRegistro === 'C' && this.busca.tipoRegistroCasamento === 'C' && this.busca.casamentoReligioso) {
          params.tipo_livro = 'CR'
          params.tipo_registro = 'CR'
          params.religioso = true
        }

        if (this.busca.tipoRegistro === 'C' && this.busca.tipoRegistroCasamento === 'D') {
          params.tipo_livro = 'D'
          params.tipo_registro = 'D'
        }

        if (this.busca.nomeConjuge) {
          params.nomeConjuge = this.busca.nomeConjuge
        }

        if (this.orderBy) {
          params.orderby = this.orderBy.value
        }

        loader({ text: 'Buscando registros...', active: true })

        try {
          const { data } = await BuscaService.searchREI(params)

          if (data.data.length === 0) {
            this.resultadoBusca = []
            this.lastPage = 1
            return this.emptyResult()
          }

          // Atualizamos os dados das páginas
          this.resultadoBusca = data.data
          this.lastPage = data.lastPage

          this.resultadoBusca.forEach(reg => {
            // Formatamos as datas
            if (reg.data_registro) {
              reg.data_registro = moment(reg.data_registro).format('DD/MM/YYYY')
            }

            if (reg.data_ocorrido) {
              reg.data_ocorrido = moment(reg.data_ocorrido).format('DD/MM/YYYY')
            }
          })

          // Verificamos se o registros recebido é o mesmo do registrado, se sim tiramos da listagem
          const resultados = this.resultadoBusca.filter(reg => reg.registro_id !== this.propRegistroId)

          this.resultadoBusca = resultados

          if (this.resultadoBusca.length === 0) {
            return this.emptyResult()
          }

          // Caso zeramos o index selecionado
          this.indexRegistroSelected = null

          if (params.tipo_registro) {
            this.tipoRegistroPesquisado = params.tipo_registro

            if (params.religioso) {
              this.tipoRegistroPesquisado = 'CR'
            }
          } else {
            // Óbito e Natimorto
            if (Array.isArray(params.tipo_livro) && params.tipo_livro[0] === 'O') {
              this.tipoRegistroPesquisado = 'O'
            }
          }
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível encontrar o(s) registro(s)'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        } finally {
          loader({ text: '', active: false })
        }
      },

      emptyResult () {
        loader({ text: '', active: false })

        objSwal.info.title = ''
        objSwal.info.text = 'Nenhum resultado encontrado'
        objSwal.info.html = ''

        return Swal.fire(objSwal.info)
      },

      selectTipoRegistro (tipoLivro) {
        if (!tipoLivro.disabled) {
          this.busca.tipoRegistro = tipoLivro.valor
        }
      },

      disableSelectRegistro (index) {
        return this.resultadoBusca[index].selos.length === 0
      },

      paginaAnterior () {
        this.page = Number(this.page) - 1

        return this.getRegistros()
      },

      selecionaPagina (page = 1) {
        this.page = Number(page)

        return this.getRegistros()
      },

      proximaPagina () {
        this.page = Number(this.page) + 1

        return this.getRegistros()
      },

      concluiSelecionarRegistro () {
        this.$emit('registroSelecionado', this.resultadoBusca[this.indexRegistroSelected])
      },
      tratarSugestao (habilitacao) {
        habilitacao = {
          ...habilitacao.registro,
          habilitacaoCasamento: { ...habilitacao }
        }

        this.resultadoBusca = [habilitacao]
        this.lastPage = 1

        this.busca = {
          ...this.busca,
          tipoRegistro: 'D',
          tipoRegistroCasamento: 'D',
          casamentoReligioso: false,
          numLivro: habilitacao.livro.num_livro,
          numFolha: habilitacao.folha,
          numTermo: habilitacao.termo,
        }

        this.resultadoBusca.forEach(reg => {
          // Formatamos as datas
          if (reg.data_registro) {
            reg.data_registro = moment(reg.data_registro).format('DD/MM/YYYY')
          }

          if (reg.data_ocorrido) {
            reg.data_ocorrido = moment(reg.data_ocorrido).format('DD/MM/YYYY')
          }
        })

        this.indexRegistroSelected = 0
        this.tipoRegistroPesquisado = 'D'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .modalVinculacaoSelo {
    &--tipoBox {
      border: 4px solid $sofiaRei-blue;
    }

    &_border-color {
      border-color: gray !important;
    }

    &_botao-voltar {
      background-color: #c8c4c4;
    }

    &_tipos_casamento {
      padding-top: 0.12rem;
      flex: 0 0 11%;
      max-width: 11%;
    }
  }

  .RegistrosResultados {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &--header {
      background-color: $sofiaRei-blue;
      min-height: 30px;
      display: flex;
      align-content: center;

      &--click{
        cursor: pointer;
      }
    }

    &--cartorio {
      font-size: 14px;
    }

    &--tipo {
      font-size: 1rem;
    }

    &--table-width {
      flex: 0 0 28%;
      max-width: 28%;
    }

    &--table {
      font-size: 12px;
      & tr:first-child {
        border-bottom: 1px solid black;
      }

      & th, td {
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    &_titulo_nascimento_casamento {
      flex: 0 0 15%;
      max-width: 15%;
    }

    &_titulo_cas_reg {
      flex: 0 0 22%;
      max-width: 22%;
    }

    &_titulo_hab {
      flex: 0 0 25%;
      max-width: 25%;
    }

    &_titulo_obito {
      flex: 0 0 10%;
      max-width: 10%;
    }

    &_opacity {
      opacity: 0.6;
    }

    @media only screen and (max-width: 1600px) {
      &_resultado {
        max-height: 25em !important;
        overflow: auto !important;
      }
    }

    @media only screen and (min-width: 1650px) {
      &_resultado {
        max-height: 30em !important;
        overflow: auto !important;
      }
    }
  }

  .paginate {
    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .radioBox {
    border: pxToRem(1) solid $color-gray-light;
    cursor: pointer;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;

    &_btn {
      cursor: pointer;
    }

    &_input {
      height: 0;
      opacity: 0;
      width: 0;
    }

    &_icon {
      fill: $color-gray-light;
    }

    &_title {
      color: $color-gray-light;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
    }

    &.active,
    &:hover {
      background-color: $sofiaRei-blue;
      border-color: $sofiaRei-blue;

      .radioBox_icon {
        fill: $color-white;
      }

      .radioBox_title {
        color: $color-white;
      }
    }
  }

  .radioBoxDisabled {
    border: pxToRem(1) solid $color-gray-light;
    background-color: $color-gray;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;

    &_btn {
      cursor: pointer;
    }

    &_input {
      height: 0;
      opacity: 0;
      width: 0;
    }

    &_icon {
      fill: $color-gray;
    }

    &_title {
      color: $color-gray;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
    }
    &.active,
     &:hover {
       background-color: $color-gray;
       border-color: $color-gray;
     }
  }
</style>
